module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_f_normal.074d1096.png";